<template>
    <div class="client-item-modal-details">
        <InputsBasicInfo :showDnbSearch="false" />

        <hr class="mt-3" />

        <InputsAdditionalInfo :showDnbSearch="false" class="mt-4" />
    </div>
</template>

<script>
import InputsBasicInfo from './InputsBasicInfo.vue'
import InputsAdditionalInfo from './InputsAdditionalInfo.vue'

export default {
    name: 'ClientItemModalDetails',

    components: {
        InputsBasicInfo,
        InputsAdditionalInfo,
    },
}
</script>